// extracted by mini-css-extract-plugin
module.exports = {"modal":"EditUser_modal__1EGTc"};